import licenseReducer from "@app/store/slices/Licence/slice";
import userAgentReducer from "@app/store/slices/UserAgent/slice";

const rootReducer = {
  license: licenseReducer,
  userAgent: userAgentReducer,
};

export default rootReducer;
